export const CLASS_CARD_CHECKLIST_ASSIGN_SELECT = 'card-details__checklist-assignees-select';
